import { AccordionIcon, AccordionButton, AccordionPanel, Box, AccordionItem, Text } from '@chakra-ui/react';
import { FC, ReactNode, Fragment } from 'react';

interface IAccordionItemResearchers {
  title: string;
  children: ReactNode;
}

export const AccordionItemResearchers: FC<IAccordionItemResearchers> = ({ title, children }) => {
  return (
    <AccordionItem _expanded={{ bg: 'red' }} mb={6} border="0">
      {({ isExpanded }) => (
        <Fragment>
          <AccordionButton
            p={6}
            _expanded={{ bg: 'white', borderBottomRadius: 0 }}
            borderRadius={8}
            borderWidth="1px"
            borderColor="transparent"
            _hover={{ bg: 'white', borderColor: isExpanded ? 'transparent' : 'gray.100' }}
          >
            <Box fontSize="xl" fontWeight="bold" as="span" flex="1" textAlign="left">
              {title}
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel p={6} pt={0} borderBottomRadius={8} bg="white">
            <Text fontSize="lg">{children}</Text>
          </AccordionPanel>
        </Fragment>
      )}
    </AccordionItem>
  );
};
